<template>
  <el-dialog
    v-if="couponListDialog"
    title="优惠券列表"
    center
    top="5vh"
    :visible.sync="couponListDialog"
    append-to-body
    width="90%"
    :before-close="btnCloseHandler"
  >
    <el-form
      :inline="true"
      :model="formData"
      class="demo-form-inline"
      size="medium"
      ref="searchForm"
    >
      <el-form-item label="优惠券状态" prop="status">
        <el-select v-model="formData.status" placeholder="请选择">
          <el-option label="未开始" :value="2"></el-option>
          <el-option label="正在进行" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="优惠券活动id" prop="id">
        <el-input
          style="width: 200px"
          v-model="formData.id"
          placeholder="优惠券活动id"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="优惠券活动名称" prop="name">
        <el-input
          style="width: 200px"
          v-model="formData.name"
          placeholder="优惠券活动名称"
          clearable
        ></el-input>
      </el-form-item>

      <span>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="reset('searchForm')">重置</el-button>
      </span>
    </el-form>
    <div style="margin-top: 20px">
      <el-table
        v-loading="loading"
        :data="tableData1"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
        ref="multipleTable"
        row-key="id"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="selected"
          reserve-selection
        ></el-table-column>
        <el-table-column prop="id" label="活动id" align="center">
        </el-table-column>
        <el-table-column prop="name" label="优惠券活动名称" align="center">
        </el-table-column>
        <el-table-column prop="couponCategory" label="分类名称" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.couponCategory == 0"
              >全场券</el-tag
            >
            <el-tag v-if="scope.row.couponCategory == 1">商品券</el-tag>
            <el-tag type="info" v-if="scope.row.couponCategory == 2"
              >运费券</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="领取时间" width="300" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.receiveStartTime">
              {{ scope.row.receiveStartTime }}至{{ scope.row.receiveEndTime }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="优惠券活动有效期(使用时间)"
          width="300"
          align="center"
        >
          <template slot-scope="scope">
            <div
              v-if="scope.row.validPeriodType == 0 && scope.row.validStartTime"
            >
              {{ scope.row.validStartTime }}~{{ scope.row.validEndTime }}
            </div>
            <div v-if="scope.row.validPeriodType == 1">
              <span v-if="scope.row.validAfterDays"
                >{{ scope.row.validAfterDays }}天后的</span
              >{{ scope.row.validDays }}天内
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="couponSubtitle"
          label="面额门槛（元）"
          align="center"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.lessAmount">
              {{ scope.row.lessAmount }}/{{ scope.row.fullAmount }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="coupon-clock-paging">
      <div>{{ selectionName }}</div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="formData.pageSize"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </div>
    <el-row type="flex" justify="center">
      <el-button @click="btnCloseHandler">取消</el-button>
      <el-button type="primary" @click="saveData">保存</el-button>
    </el-row>
  </el-dialog>
</template>

<script>
import { queryCouponList } from "@/api/shop/couponManage";
export default {
  name: "couponList",
  props: [
    "maxCount",
    "couponListDialog",
    "couponListData",
    "sendTime",
    "canMultipleChoice",
    "SelectedCouponList"
  ],
  components: {},
  data() {
    return {
      formData: {
        id: "",
        name: "",
        status: 3,
        couponCategory: "", // 优惠券类别: 0 全场、1 商品、2 包邮
        page: 1,
        // sendLimit: 0,
        pageSize: 10
      },
      loading: false,
      tableData1: [], //表单数据
      total: 0, //总条数
      selectedIds: [],
      selectionData: [] //选中数据
    };
  },
  watch: {
    couponListDialog: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.queryCouponList();
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    coupons() {
      const parmas = this.selectionData.concat(this.SelectedCouponList || []);
      const uniqueArray = this.uniqueById(parmas, "id");
      return uniqueArray;
    },
    selectionName: function() {
      if (this.coupons && this.coupons.length) {
        return this.coupons.map(item => item.name).join(",");
      }
    }
  },
  methods: {
    uniqueById(array, property) {
      return array.filter(
        (obj, index, self) =>
          index === self.findIndex(o => o[property] === obj[property])
      );
    },
    search() {
      this.formData.page = 1;
      this.queryCouponList();
    },
    reset(formName) {
      //重置查询
      this.formData.page = 1;
      this.$refs[formName].resetFields();
      this.queryCouponList();
    },

    //修改每页数量
    handleSizeChange(val) {
      this.formData.pageSize = val;
      this.formData.page = 1;
      this.queryCouponList();
    },
    handleSelectionChange(val) {
      //修改选中数据
      this.selectionData = val;
    },
    selected(row, index) {
      if (this.selectedIds.indexOf(row.id) >= 0) {
        return false;
      } else {
        return true;
      }
    },
    saveData() {
      const { canMultipleChoice, coupons } = this;
      if (canMultipleChoice) {
        if (this.maxCount && coupons.length > this.maxCount) {
          this.$message.warning("最多只能选择" + this.maxCount + "个优惠券");
          return;
        }

        if (coupons.length) {
          this.$emit("couponListSelect", coupons);
          this.btnCloseHandler();
        } else {
          this.$message.warning("请选择优惠券");
        }
        return;
      }

      //保存提交数据
      if (selectionData.length == 1) {
        this.$emit("couponListSelect", selectionData);
      } else if (selectionData.length > 10) {
        this.$message.warning("请选择小于等于10个以内的优惠券");
      } else {
        this.$message.warning("一次只能选中一张优惠券");
      }
    },
    //切换页面
    handleCurrentChange(val) {
      this.formData.page = val;
      this.queryCouponList();
    },
    btnCloseHandler() {
      this.selectedIds = [];
      this.selectionData = [];
      this.$emit("closecCouponListDialog", false);
    },
    async queryCouponList(e) {
      this.loading = true;
      //获取数据
      const data = {
        ...this.formData,
        sendTime: this.sendTime
      };
      const res = await queryCouponList(data);
      if (res.code === 200) {
        this.tableData1 = res.data.rows ? res.data.rows : [];
        this.total = res.data.count;

        let arryAll = this.SelectedCouponList
          ? this.SelectedCouponList.map(v => v.id)
          : [];

        const arry = this.tableData1;

        for (let i in arry) {
          if (
            arryAll.indexOf(arry[i].id) >= 0 &&
            this.selectedIds.indexOf(arry[i].id) == -1
          ) {
            this.$refs.multipleTable.toggleRowSelection(arry[i]);
            this.selectedIds.push(arry[i].id);
          }
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped lang="less">
.product-sort-html {
  padding: 20px;
}

.coupon-clock-paging {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/SelectCouponDialog.vue